import * as React from 'react';
import { FC } from 'react';

import { StyleSheet } from 'react-native';

import PointsIcon from 'components/icons/loyalty-points-icon';
import { Box, Typography } from 'components/ui';

import getPointsLabel from './get-points-label';
import { IEarnedPointsProps } from './types';

const PointsEarned: FC<React.PropsWithChildren<IEarnedPointsProps>> = ({ lylTransaction }) => {
  const pointsEarned = lylTransaction.pointsEarned + lylTransaction.bonusPointsEarned;

  if (!pointsEarned) {
    return null;
  }

  return (
    <Box style={styles.container}>
      <PointsIcon mr="$1" size={5} />
      <Typography variant="headerFour" style={styles.pointsText}>
        {getPointsLabel(pointsEarned)}
      </Typography>
    </Box>
  );
};

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    alignContent: 'center',
  },
  pointsText: {
    margin: 0,
    lineHeight: 20,
  },
});

export default PointsEarned;
